import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/login-image.png'


const _withScopeId = n => (_pushScopeId("data-v-7bea63e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column flex-lg-row flex-column-fluid",
  id: "login-container"
}
const _hoisted_2 = {
  class: "d-flex flex-column flex-lg-row-fluid flex-lg-row-auto py-10 w-50-p",
  style: {"background":"#fff"}
}
const _hoisted_3 = { class: "d-flex flex-center flex-column flex-column-fluid" }
const _hoisted_4 = { class: "w-lg-500px p-10 p-lg-15 mx-auto login-form-container" }
const _hoisted_5 = { class: "text-center mb-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3 text-sign-in" }, "New Password", -1))
const _hoisted_7 = { class: "fs-4 subtext-sign-in" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Please create a new password for your account ")
const _hoisted_9 = { class: "login-links" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Support")
const _hoisted_12 = {
  class: "d-flex w-50-p aside justify-content-center align-items-center",
  style: {"background-color":"#3e1f92"}
}
const _hoisted_13 = { class: "d-flex flex-column justify-content-center align-items-center pt-10" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "login-image"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-heading-text text-center" }, " Looking for the perfect tenant? Reach for the stars! ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainLogo = _resolveComponent("MainLogo")!
  const _component_AlertInfo = _resolveComponent("AlertInfo")!
  const _component_ResetPasswordForm = _resolveComponent("ResetPasswordForm")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MainLogo, { class: "logo-app-mobile m-auto" }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "form w-100",
            novalidate: "novalidate",
            id: "kt_sign_in_form",
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitResetPasswordForm && _ctx.submitResetPasswordForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_AlertInfo, null, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_ResetPasswordForm),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: "/sign-up",
                class: "link",
                style: {"margin-right":"40px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/sign-up",
                class: "link"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_MainLogo, { class: "logo" }),
        _hoisted_14,
        _hoisted_15
      ])
    ])
  ]))
}